export function clickElement(element: string) {
  const btn = document.querySelector(element) as HTMLElement
  btn?.click()
}
